var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-form mb-40 mb-lg-0" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            loading: _vm.loading,
            success: _vm.success,
            error: _vm.server_error
          },
          on: { submit: _vm.submit }
        },
        [
          _c("p", { staticClass: "h3 font-weight-bold mb-40" }, [
            _vm._v("Contacteer ons")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row mb-24" },
            [
              _c("el-input", {
                staticClass: "col-12 mb-24",
                attrs: { label: "Voornaam", rules: "required" },
                model: {
                  value: _vm.data.first_name,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "first_name", $$v)
                  },
                  expression: "data.first_name"
                }
              }),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "col-12 mb-24",
                attrs: { label: "Achternaam", rules: "required" },
                model: {
                  value: _vm.data.last_name,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "last_name", $$v)
                  },
                  expression: "data.last_name"
                }
              }),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "col-12 mb-24",
                attrs: { label: "Bedrijf", rules: "required" },
                model: {
                  value: _vm.data.company,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "company", $$v)
                  },
                  expression: "data.company"
                }
              }),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "col-12 mb-24",
                attrs: {
                  type: "email",
                  label: "E-mailadres",
                  rules: "required|email"
                },
                model: {
                  value: _vm.data.email,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "email", $$v)
                  },
                  expression: "data.email"
                }
              }),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "col-12 mb-24",
                attrs: { label: "Telefoonnummer", rules: "required" },
                model: {
                  value: _vm.data.phone,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "phone", $$v)
                  },
                  expression: "data.phone"
                }
              }),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "col-12 mb-0",
                attrs: { type: "textarea", label: "Bericht" },
                model: {
                  value: _vm.data.message,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "message", $$v)
                  },
                  expression: "data.message"
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }